// extracted by mini-css-extract-plugin
module.exports = {"blockIcon":"IconGallery__blockIcon___etb17","smallIcon":"IconGallery__smallIcon___38EwN"};